var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBg1Icon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 319 47"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5FD4D4",
  fillOpacity: 0.25,
  d: "M319 .23c0 8.847-71.411 16.018-159.5 16.018C71.41 16.248 0 9.077 0 .23v46c0-8.846 71.41-16.017 159.5-16.017 88.089 0 159.5 7.171 159.5 16.017z"
})));
export default SvgBg1Icon;